export default "__VITE_ASSET__K2qjcFyZWmTDXU9Uy6BgHQ__";